// extracted by mini-css-extract-plugin
export default {"MyNavbar":"MyNavbar_MyNavbar__iPAb5"};